import {Button, Col, Form, FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {DataListView} from "../grouping/DataListView";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {Section} from "../grouping/Section";
import {useCallback, useState} from "react";
import {useMembers} from "../../api/memberapi";
import {usePages, usePagesMutations} from "../../api/pageapi";
import {SelectionList} from "../SelectionList";
import {ListItemButton} from "../ListItemButton";
import {ALBUM_EMPTY, useAlbumsMutations} from "../../api/albumapi";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {useFragments} from "../../api/htmlfragmentapi";
import {ButtonLoading} from "../ButtonLoading";

export function PageConfigOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [openImportExportModal, setOpenImportExportModal] = useState(false)
    const [fileEditing, setFileEditing] = useState(undefined);
    const {pages} = usePages();
    return <Section title={title}>
        <SelectionList>
            <p>Hier kan je een html fragment selecteren dat dan wordt getoond op de geselecteerde pagina</p>
            {pages ? pages.map(a => <ListItem key={a.id} onOpenChanged={setOpen}
                                              album={a}
                                              onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw bestand link"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>
    </Section>
}
function ListItem(props) {
    const {album, onOpenChanged, icon, onFileEditingChanged} = props;

    return <ListItemButton onClick={() => {
        onFileEditingChanged(album);
        onOpenChanged(true);
    }}>
        <Col className={"text-start"}>
            {album ? album.title : "Geen Titel"}
        </Col>
        <Col xs={"auto"} className={"text-end"}>
            {icon}
        </Col>
    </ListItemButton>
}
function FileOptionModalContent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {editPage} = usePagesMutations();
    const initialObjectInintializer = useCallback(() => {
        return {...fileEditing, htmlFragment: fileEditing.htmlFragment ? fileEditing.htmlFragment.id : 1}
    }, []);
    const {fragments} = useFragments();
    const {tempObject, onChange} = useForm(initialObjectInintializer)

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editPage({...tempObject, htmlFragment: {id: tempObject.htmlFragment}});
        if (result) {
            setFileEditing(undefined);
            onOpenChanged(false);
        }

        setIsLoading(false);

    }
    console.log(tempObject)
    console.log(fragments)
    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form>
            <Section title={fileEditing ? "Wijzig pagina inhoud" : "Nieuwe pagina"}>
                <FormGroup>
                    <FormLabel>Titel</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                </FormGroup>
                <FormGroup>
                    <FormLabel>Omschrijving</FormLabel>
                    <FormControl value={tempObject ? tempObject.description : ""}
                                 onChange={event => onChange(event, "description")}/>
                </FormGroup>
                <FormGroup>
                    <FormGroup>
                        <FormLabel>HtmlFragment</FormLabel>
                        <FormSelect
                            onChange={event => onChange(event, "htmlFragment")}>
                            {fragments?.map(f => <option selected={f.id === tempObject.htmlFragment} value={f.id}>{f.title}</option>)}
                        </FormSelect>
                    </FormGroup>
                </FormGroup>
                <Col xs={12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(event) => {
                        setIsLoading(true);
                        handleEditSubmit(event);
                    }}/>
                </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}